import LocalDataHandler from "@/utils/handlers/LocalDataHandler";

/** Menu**/
export const SET_SELECTED_MENU_ITEM = 'setSelectedMenuItem';

export const mutations = {

  /** Menu**/
  setSelectedMenuItem(state, data) {
    state.selectedMenuItem = data;
    LocalDataHandler.saveMenuItem(data);
  }
};
